export default __webpack_public_path__ + "static/media/search-no-results-3x.e00a60ab.png";